import { useLocation } from 'react-router-dom';
import { parse as parseQueryString } from 'query-string';
import type { ParsedQuery } from 'query-string';

function useSearchParams(): ParsedQuery {
  return parseQueryString(useLocation().search);
}

export default useSearchParams;
